import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { PageNotFound } from './site/page-not-found/page-not-found';
import { Services } from './pages/services/services';
import { Rates } from './pages/rates/rates';
import { Contact } from './pages/contact/contact';

export const routes: Routes = [
  { path: 'home', component: Home },
  { path: 'services', component: Services },
  { path: 'rates', component: Rates },
  { path: 'contact', component: Contact },
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: '**', component: PageNotFound },
];
